import {Filter} from '../core/filter/filter';

export class PurchaseRequestFilter extends Filter {
  text?: string;
}
